/**
 * Goods Sales Store
 *
 * @author minkyoung.park@emcast.com
*/
// states
const state = {
    likeCount: 0,
    viewCount: 0,
    userAuthDetail: null,
}

// getters
const getters = {}


// actions
const actions = {
    SET_LIKE({ commit } , value) {
        commit('SET_LIKE_STORE', value)
    },
    SET_VIEW({ commit } , value) {
        commit('SET_VIEW_STORE', value)
    },
    SET_USER_AUTH_DETAIL({ commit } , value) {
        commit('GET_USER_AUTH_DETAIL', value)
    }

}


// mutations
const mutations = {
    SET_LIKE_STORE(state, value) {
        state.likeCount = value
    },
    SET_VIEW_STORE(state, value) {
        state.viewCount = value
    },
    GET_USER_AUTH_DETAIL(state, value) {
        state.userAuthDetail = value
    },
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}